// extracted by mini-css-extract-plugin
export default {"strip-columns-container":"CohWsy","stripColumnsContainer":"CohWsy","columns":"V5AUxf","fix-flashing-content":"LIhNy3","fixFlashingContent":"LIhNy3"};